import { render, staticRenderFns } from "./delete-image.vue?vue&type=template&id=63b1e4f7&"
import script from "./delete-image.vue?vue&type=script&lang=js&"
export * from "./delete-image.vue?vue&type=script&lang=js&"
import style0 from "./delete-image.vue?vue&type=style&index=0&id=63b1e4f7&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports